import { trendBoard } from "@/mocks/gua";

const catColor: Record<string, string> = {
  音乐: "bg-primary-100 text-primary-800",
  直播: "bg-secondary-100 text-secondary-900",
  影视: "bg-accent-100 text-accent-800",
  综艺: "bg-secondary-100 text-secondary-900",
  品牌: "bg-accent-100 text-accent-800",
  电竞: "bg-primary-100 text-primary-800",
};

export default function TrendBoard() {
  return (
    <section id="board" className="scroll-mt-20 bg-background-100/70 py-12 md:py-16">
      <div className="wrap">
        <div className="flex flex-col gap-2 sm:flex-row sm:items-end sm:justify-between">
          <div>
            <span className="inline-flex items-center gap-1.5 rounded-full bg-secondary-100 px-3 py-1 text-xs font-medium text-secondary-900">
              <i className="ri-fire-fill" aria-hidden="true"></i>
              HOT 榜单 · 更新于刚刚
            </span>
            <h2 className="mt-3 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
              今日热度榜<span className="text-primary-500"> · 都在吵什么</span>
            </h2>
            <p className="mt-2 text-sm text-foreground-600">
              热度由讨论量、互动与搜索走势综合计算，辅助你快速找到最值得吃的那口瓜。
            </p>
          </div>
          <a
            href="#feed"
            className="inline-flex shrink-0 items-center gap-1 whitespace-nowrap rounded-md border border-background-300 bg-background-50 px-4 py-2 text-sm text-foreground-700 transition-colors hover:border-primary-300 hover:text-primary-700"
          >
            刷新榜单
            <i className="ri-refresh-line" aria-hidden="true"></i>
          </a>
        </div>

        <div className="mt-6 grid gap-4 lg:grid-cols-3">
          {/* 榜单主体占两列 */}
          <div className="lg:col-span-2">
            <div className="flex flex-col gap-3">
              {trendBoard.map((item, idx) => (
                <div
                  key={item.rank}
                  className="flex flex-col gap-3 rounded-xl border border-background-200 bg-background-50 p-4 sm:flex-row sm:items-center md:p-5"
                >
                  <div className="flex items-center gap-3 sm:w-16 sm:shrink-0">
                    <span
                      className={
                        "flex h-9 w-9 shrink-0 items-center justify-center rounded-lg font-heading text-base font-bold " +
                        (idx < 3 ? "bg-secondary-500 text-background-50" : "bg-background-200 text-foreground-700")
                      }
                    >
                      {item.rank}
                    </span>
                    <span className="sm:hidden text-xs text-foreground-500">{item.time}</span>
                  </div>

                  <div className="min-w-0 flex-1">
                    <a href="#feed" className="text-base font-semibold text-foreground-900 transition-colors hover:text-primary-600">
                      {item.title}
                    </a>
                    <div className="mt-2 flex items-center gap-2">
                      <span className={"whitespace-nowrap rounded px-1.5 py-0.5 text-[11px] font-medium " + (catColor[item.cat] ?? "bg-background-200 text-foreground-700")}>
                        {item.cat}
                      </span>
                      <span
                        className={
                          "flex items-center gap-1 whitespace-nowrap rounded px-1.5 py-0.5 text-[11px] font-medium " +
                          (item.trend === "up"
                            ? "bg-accent-100 text-accent-800"
                            : item.trend === "down"
                              ? "bg-background-200 text-foreground-500"
                              : "bg-secondary-100 text-secondary-900")
                        }
                      >
                        <i
                          className={
                            item.trend === "up"
                              ? "ri-arrow-up-line"
                              : item.trend === "down"
                                ? "ri-arrow-down-line"
                                : "ri-arrow-right-line"
                          }
                          aria-hidden="true"
                        ></i>
                        {item.delta}
                      </span>
                      <span className="hidden whitespace-nowrap text-xs text-foreground-400 md:inline">{item.time}</span>
                    </div>
                  </div>

                  <div className="flex items-center gap-3 sm:w-40 sm:shrink-0 sm:flex-col sm:items-end">
                    <div className="h-1.5 w-full max-w-[120px] overflow-hidden rounded-full bg-background-200">
                      <div
                        className="h-full rounded-full bg-gradient-to-r from-secondary-500 to-primary-500"
                        style={{ width: `${item.heat}%` }}
                      ></div>
                    </div>
                    <span className="font-heading text-lg font-bold text-foreground-950">{item.heat}</span>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* 右侧：进行时 / 快讯卡 */}
          <div className="flex flex-col gap-4">
            <div className="rounded-2xl border border-background-200 bg-background-50 p-5">
              <h3 className="flex items-center gap-2 font-heading text-base font-bold text-foreground-950">
                <span className="flex h-8 w-8 items-center justify-center rounded-lg bg-accent-500 text-background-50">
                  <i className="ri-flashlight-fill" aria-hidden="true"></i>
                </span>
                正在发酵
              </h3>
              <ul className="mt-4 flex flex-col divide-y divide-background-100">
                <li className="flex items-start gap-3 py-3">
                  <span className="relative mt-1 flex h-2 w-2">
                    <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-accent-500 opacity-60"></span>
                    <span className="relative inline-flex h-2 w-2 rounded-full bg-accent-600"></span>
                  </span>
                  <div>
                    <p className="text-sm font-medium text-foreground-900">「假唱」声学报告仍在扩散</p>
                    <p className="mt-1 text-xs text-foreground-500">多平台分词条新增讨论约 1.2 万</p>
                  </div>
                </li>
                <li className="flex items-start gap-3 py-3">
                  <span className="relative mt-1 flex h-2 w-2">
                    <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-accent-500 opacity-60"></span>
                    <span className="relative inline-flex h-2 w-2 rounded-full bg-accent-600"></span>
                  </span>
                  <div>
                    <p className="text-sm font-medium text-foreground-900">品牌联名海报旧图对比出圈</p>
                    <p className="mt-1 text-xs text-foreground-500">话题互动量较昨日提升 340%</p>
                  </div>
                </li>
                <li className="flex items-start gap-3 py-3">
                  <span className="relative mt-1 flex h-2 w-2">
                    <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-accent-500 opacity-60"></span>
                    <span className="relative inline-flex h-2 w-2 rounded-full bg-accent-600"></span>
                  </span>
                  <div>
                    <p className="text-sm font-medium text-foreground-900">主播转会谈判进入尾声</p>
                    <p className="mt-1 text-xs text-foreground-500">多方陆续放出「接近达成」信号</p>
                  </div>
                </li>
              </ul>
            </div>
            <div className="rounded-2xl bg-primary-500 p-5 text-background-50">
              <p className="text-sm font-medium">提示：榜单热度会实时变化，进入下方</p>
              <p className="brand-face mt-1 text-xl">「时间线 · 完整复盘」更稳更耐吃。</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}